import { isEscape, returnFocus, trapFocus, throttle } from "./app/utils.js";

require('./vendor/bootstrap-requires');
require('./app/logo-highlights');
require('./app/modals');
require('./app/image-carousel');
require('./app/testimonial-carousel');
require('./app/instant-quote');
require('./app/forms');
require('./app/accordion');
require('./app/site-header');
require('./app/see-more');
require('./app/careers');
require('./app/telephone-classes');

var returnFocusTo = window.returnFocusTo || null;
const breakpoints = {
    xs: 0,
    md: 768,
    lg: 1025,
    xl: 1536
};

/*
ADA
*/
document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        // close things then return focus
        returnFocus();
    }
});
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
if (!!isReduced) {
    const heroVideo = document.querySelector('.wp-block-pulp-hero video');
    if (heroVideo) {
        heroVideo.pause();
    }
}

/*
Mobile UI
*/
// document.getElementById('site-navigation-open').addEventListener('click', e => {
//     e.preventDefault();
//     document.body.classList.add('menu-open');
// });
//
// document.getElementById('site-navigation-close').addEventListener('click', e => {
//     e.preventDefault();
//     document.body.classList.remove('menu-open');
// });

/*
Scroll events
*/
window.addEventListener('scroll', throttle(100, function () {
    if (window.scrollY > 0) {
        document.body.classList.add('is-scrolled');
        return;
    }
    document.body.classList.remove('is-scrolled');
}));

// look for an a tag with a hash in the url and Cities as the text
// $("a[href*='#']").each(function() {
//     if($(this).text().trim() === 'Cities') {
//         $(this).append('<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
//             '<path d="M11 1L6 6L1 1" stroke="#D54500" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
//             '</svg>\n');
//     }
// });
// $('.sub-menu .menu-item-has-children > a').append('<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
//     '<path d="M1 1L6 6L1 11" stroke="#D54500" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
//     '</svg>\n');
